import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function PricingSectionV2() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const currentPrice = 27;
  return <section ref={ref} className="w-full py-20 px-4" data-id="element-391">
      <div className="max-w-6xl mx-auto" data-id="element-392">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-393">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-394">
            Empieza a Ganar Esta Semana por{' '}
            <span className="text-gold" data-id="element-395">${currentPrice}</span>
          </h2>
          <p className="font-body text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-396">
            {'Precio de lanzamiento: $27 (pago único).'}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-gradient-to-br from-navy-dark to-navy border-2 border-gold/30 rounded-2xl p-8 md:p-12 mb-8" data-id="element-397">
          {/* Product Image */}
          <div className="mb-8" data-id="element-398">
            <motion.img initial={{
            opacity: 0,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} src="https://cdn.magicpatterns.com/uploads/ehm6JeHJmPrRFh28GURN6r/ai_web_closer_bundle_mockup.png" alt="AI Web Closer System - Complete bundle showing dashboard, AI brains, modules, closing script, price calculator, and $50M+ generated proof" className="w-full h-auto rounded-lg" data-id="element-399" />
          </div>

          <div className="text-center mb-8" data-id="element-400">
            <h3 className="font-heading font-bold text-2xl md:text-3xl mb-4" data-id="element-401">
              Acceso al Curso Completo
            </h3>
            <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-402">
              <span className="font-heading font-black text-5xl md:text-6xl text-gold" data-id="element-403">
                $27
              </span>
              <span className="font-body text-lg text-gray-400" data-id="element-404">
                pago único
              </span>
            </div>
            <p className="font-body text-sm text-gray-400" data-id="element-405">
              Incluye todos los módulos, cerebros de IA, guiones y calculadora
            </p>
          </div>

          <motion.a href="/checkout" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group w-full bg-gold hover:bg-gold-light text-navy font-heading font-bold text-xl px-8 py-5 rounded-xl shadow-2xl transition-all duration-300 flex items-center justify-center gap-3 mb-4" data-id="element-406">
            QUIERO ACCESO POR ${currentPrice}
            <ArrowRightIcon className="h-6 w-6 group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-407" />
          </motion.a>

          <p className="text-center font-body text-sm text-gray-400 max-w-2xl mx-auto" data-id="element-408">
            El software de IA que usarás tiene un plan desde $20/mes — menos de
            lo que cobras por un solo sitio web. Se paga solo con tu primera
            venta.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="bg-gold/10 border border-gold/30 rounded-xl p-6 text-center" data-id="element-409">
          <p className="font-body text-base text-gray-300" data-id="element-410">
            ⚠️ Este precio sube a $97 el Viernes 11 de Abril. Accede ahora.
          </p>
        </motion.div>
      </div>
    </section>;
}